module.exports = __webpack_public_path__ + "static/media/logo_white.44347f60.svg";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/logo_white.svg
// module id = 4834
// module chunks = 0